module.exports = __webpack_public_path__ + "img/C05TechGallicHorsemanChampion_ua.3707fab2.webp";